import React from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';

import { Card, AuthComponent, PasswordReset, NetworkLoader } from '../components';
import { AuthDelegate } from '../utils';
import { routes, fetchTypes } from '../constants';
import { RouteActions, ResourceActions } from '../actions';

class AccountPage extends AuthComponent {

    componentWillMount(){
        super.componentWillMount();
        RouteActions.setAppState(routes.ACCOUNT);
    }

    userIsAuthorized(user) {
        return AuthDelegate.userIsLoggedIn()(user);
    }

    componentWillRejectUser() {
        browserHistory.push(routes.FORGOT_PASSWORD);
    }

    handleSubmit(output) {
        this.props.dispatch(ResourceActions.resourceFetch(fetchTypes.CHANGE_PASSWORD, output));
    }

    authRender () {

        return (
            <div className="container component-login-widget" id="container-forgot-password">
                <div className="row center-cols">
                    <div className="col-md-6 col-lg-5 center">
                        <Card>
                            <div className="card-title-area">
                                <h3>Account Settings</h3>
                            </div>
                            <div className="card-body">
                                <div className="option">
                                    <h4 className="option-header">Change Password</h4>
                                    <NetworkLoader status={this.props.passwordChangeStatus.status}>
                                        <PasswordReset onSubmit={(output) => this.handleSubmit(output)} />
                                    </NetworkLoader>
                                </div>
                            </div>
                        </Card>
                    </div>
                </div>
            </div>
        )
    }
}

function select(state) {
    return {
        user: state.activeUser,
        passwordChangeStatus: state.passwordChangeStatus
    }
}

export default connect(select)(AccountPage);



// WEBPACK FOOTER //
// ./web-app/containers/account.jsx